import {googleChartsVersion} from './gviz-draw-chart';

export default function(){
    // Load the Visualization API.
    google.charts.load(googleChartsVersion, {'packages':['corechart']});
    google.charts.setOnLoadCallback(drawChart);
}

/**
 * Example taken from https://developers.google.com/chart/interactive/docs/gallery/piechart
 */
function drawChart() {

    const data = google.visualization.arrayToDataTable([
        ['Task', 'Hours per Day'],
        ['Work',     11],
        ['Eat',      2],
        ['Commute',  2],
        ['Watch TV', 2],
        ['Sleep',    7]
    ]);

    const options = {
        width: 430,
        height: 240,
        title: 'My Daily Activities'
    };

    const chart = new google.visualization.PieChart(document.getElementById('google-charts-example'));

    chart.draw(data, options);
}